import "./Selector.css";
import { useState, useRef, useEffect } from "react";

interface SelectorOption {
    key: string;
    label: string;
}

interface SelectorProps {
    options: SelectorOption[];
    selectedKey: string;
    onSelect: (key: string) => void;
    placeholder?: string;
}

export function Selector({ options, selectedKey, onSelect, placeholder = 'Select' }: SelectorProps) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const currentOption = options.find(opt => opt.key === selectedKey);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (key: string) => {
        onSelect(key);
        setIsOpen(false);
    };

    return (
        <div className="selector" ref={dropdownRef}>
            <div className="selector-trigger" onClick={() => setIsOpen(!isOpen)}>
                <span className="selector-label">{currentOption?.label || placeholder}</span>
                <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
            </div>
            
            {isOpen && (
                <div className="selector-dropdown">
                    {options.map(option => (
                        <div
                            key={option.key}
                            className={`selector-option ${option.key === selectedKey ? 'selected' : ''}`}
                            onClick={() => handleSelect(option.key)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
